
import { InjectionToken } from '@angular/core';

import { OverlayImage, OverlayVideo, OverlayText } from '@softools/softools-core';

export const OVERLAY_IMAGE_DATA = new InjectionToken<OverlayImage>('OVERLAY_IMAGE_DATA');
export const OVERLAY_VIDEO_DATA = new InjectionToken<OverlayVideo>('OVERLAY_VIDEO_DATA');
export const OVERLAY_TEXT_DATA = new InjectionToken<OverlayText>('OVERLAY_TEXT_DATA');
